import { Injectable } from '@angular/core';

import { City } from "../interfaces/city.interface";

import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CitySelectedService {

  private selectedCity: BehaviorSubject<City> = new BehaviorSubject<City>(null);

  constructor() {

  }

  public getSelectedCity(): City{
    return this.selectedCity.getValue()
  }

  public getSelectedCitySubject(): BehaviorSubject<City>{
    return this.selectedCity
  }

  public setSelectedCity(c: City){
    this.selectedCity.next(c)
  }

  public clearSelectedCity(){
    this.selectedCity.next( null );
  }
}
